import React from "react"
import { connect } from "react-redux"
import Panel from "../components/cash-payout-panel"

const mapStateToProps = state => ({
  ...state.cashPayout
})

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch({type: "CASH_PAYOUT.CANCEL"}),
  onChange: (e) => dispatch({type: "CASH_PAYOUT.CHANGE", payload: e.target}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Panel)
